import React, { useState } from "react";
import Pagination from "./Pagination";

const withPagination = (WrappedComponent, limit) => {
  return ({ data, ...props }) => {
    const [page, setPage] = useState(1);

    const total = data.length;
    const totalPages = Math.ceil(total / limit);

    const currentPageData = data.slice((page - 1) * limit, page * limit);

    const handlePageChange = (type) => {
      if (type === "next" && page < totalPages) {
        setPage((prev) => prev + 1);
      } else if (type === "prev" && page > 1) {
        setPage((prev) => prev - 1);
      }
    };

    return (
      <div>
        <WrappedComponent data={currentPageData} {...props} />
        <Pagination
          setPage={setPage}
          onPageChange={handlePageChange}
          total={total}
          totalPages={totalPages}
          page={page}
        />
      </div>
    );
  };
};

export default withPagination;
